/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

/** ====================================================================================================================
 * Day.js
 * https://github.com/iamkun/dayjs
 =====================================================================================================================*/
// import dayjs from 'dayjs';
// import 'dayjs/locale/sr'
// import 'dayjs/locale/en'
// window.dayjs = dayjs;
// dayjs.locale(window.locale);

/** ====================================================================================================================
 * Vue.js
 * https://vuejs.org/
 =====================================================================================================================*/
// TODO bring back vue
// window.Vue = require('vue');


/** ====================================================================================================================
 * jQuery form validation parsley.js
 * http://parsleyjs.org/
 =====================================================================================================================*/
// var parsley = require('parsleyjs');
// require('parsleyjs/dist/i18n/sr');
// require('./basic-form');


/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i);
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// TODO bring back vue component
// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// TODO bring back vue
// const app = new Vue({
//     el: '#app',
// });
